<script>
export default {
  components: {},
  methods: {
    modalSave: function () {
      var component = this.component.edit;
      var action = "add";

      if (this.selectedNews) {
        component = this.selectedNews;
        action = "edit";
      }

      this.handler.action(component, action, [
        this.title,
        parseInt(this.date.getTime() / 1000),
        this.content,
      ]);

      this.showEditModal = false;
      this.selectedNews = null;
    },
  },
  props: ["component", "handler"],
  data: function () {
    return {
      editable: false,
      showDeleteModal: false,
      showEditModal: false,
      selectedNews: null,
      title: "",
      date: new Date(),
      content: "",
    };
  },
  computed: {
    orderedNews: function () {
      return Object.values(this.component.news).sort(function (a, b) {
        return parseInt(a.date) - parseInt(b.date);
      });
    },
  },
  watch: {
    selectedNews: function () {
      if (this.selectedNews) {
        this.title = this.selectedNews.title;
        this.date = new Date(
          this.selectedNews.date * 1000
        );
        this.content = this.selectedNews.content;
      } else {
        this.title = "";
        this.date = new Date();
        this.content = "";
      }
    },
  },
};
</script>
<template>
  <div class="home24-news" :class="{ editable }">
    <f-modal-base
      v-if="showDeleteModal"
      closable
      :title2="$vt('Delete news')"
      @close="showDeleteModal = false"
    >
      <template #content>
        {{ $vt("Are you sure you want to delete news") }} '{{
          selectedNews.title
        }}'</template
      >
      <template #actions>
        <f-button
          type="tertiary danger"
          @click="
            handler.action(selectedNews, 'delete');
            selectedNews = null;
            showDeleteModal = false;
          "
          >{{ $vt("Yes") }}</f-button
        >
        <f-button type="tertiary" @click="showDeleteModal = false">{{ $vt("No") }}</f-button>
      </template>
    </f-modal-base>

    <f-modal-base
      v-if="showEditModal"
      closable
      :title2="$vt('Add/Edit news')"
      @close="showEditModal = false"
    >
      <template #content>
        <f-textfield :input.sync="title">
          <template #label>
            {{ "Title" | vtranslate }}
          </template>
        </f-textfield>
        <f-date :date.sync="date">
          <template #label>
            {{ "Date" | vtranslate }}
          </template>
        </f-date>
        <f-textarea :input.sync="content"
          ><template #label>
            {{ "Content (HTML allowed)" | vtranslate }}
          </template></f-textarea
        >
      </template>

      <template #actions>
        <f-button type="tertiary" @click="showEditModal = false"
          >{{ $vt("Close") }}</f-button
        >
        <f-button type="primary" @click="modalSave()">{{ $vt("Save") }}</f-button>
      </template>
    </f-modal-base>

    <div
      class="home24-box"
      v-for="(news, nid) in orderedNews"
      :key="news['#id']"
    >
      <div class="title">{{ news.title }}</div>
      <div class="date">
        {{ (news.date * 1000) | angularFilter("yyyy, d of MMMM", "date") }}
      </div>
      <div class="content" v-html="news.content"></div>
      <div class="actions" v-if="editable">
        <f-button
          type="secondary"
          @click="
            showEditModal = true;
            selectedNews = news;
          "
          >{{ $vt("Edit") }} <f-icon icon="fa6-pen"></f-icon
        ></f-button>
        <f-button
          type="danger"
          @click="
            showDeleteModal = true;
            selectedNews = news;
          "
          >{{ $vt("Delete") }} <f-icon icon="fa6-trash"></f-icon
        ></f-button>
      </div>
    </div>

    <div class="actions">
      <f-button
        type="secondary"
        v-if="component.edit && !editable"
        @click="editable = true"
        >{{ $vt("Edit") }}<f-icon icon="fa6-pen"></f-icon
      ></f-button>
      <f-button type="secondary" v-if="editable" @click="showEditModal = true"
        >{{ $vt("Add") }} <f-icon icon="fa6-plus"></f-icon
      ></f-button>
      <f-button type="secondary" v-if="editable" @click="editable = false"
        >{{ $vt("Done") }} <f-icon icon="fa6-check"></f-icon
      ></f-button>
    </div>
  </div>
</template>

<style lang="scss">
.home24-news {
  display: flex;
  flex-direction: column;
  gap: 24px;
  > .actions {
    display: flex;
    gap: 24px;
  }
  > .home24-box {
    display: flex;
    border-left-color: var(--white-a25);
    flex-wrap: wrap;
    > .actions {
      margin-top: 8px;
      display: flex;
      gap: 8px;
    }

    > .title {
      color: var(--white-a90);
      text-align: center;
      font-family: Lato;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
    }

    > .date {
      margin-left: auto;
      color: var(--white-a90);
      text-align: center;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
    }

    > .content {
      width: 100%;
      margin-top: 8px;
      color: var(--white-a75);
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 17.5px */
    }
  }
}
</style>